var selectors = {};

function _initializeSelectors(){
    selectors.body = document.body;
    selectors.drawer = document.querySelector('#sidebar-cart');
    selectors.popup = document.querySelector('#swymcs-add-to-wishlist-popup-container');
    selectors.close = selectors.popup.querySelector('#swymcs-close-add-to-wishlist-popup');
    selectors.cancel = selectors.popup.querySelector('#swymcs-add-to-wishlist-cancel');
    selectors.image = selectors.popup.querySelector('#swymcs-add-to-wishlist-image img');
    selectors.name = selectors.popup.querySelector('#swymcs-add-to-wishlist-title');
    selectors.variant = selectors.popup.querySelector('#swymcs-add-to-wishlist-variant');
    selectors.add = selectors.popup.querySelector('#swymcs-add-to-wishlist-button');
}

async function _getListID(swat) {
    try {
        const lists = await new Promise((resolve, reject) => {swat.fetchLists({ callbackFn: resolve, errorFn: reject });});
        if (lists.length > 0) {
            let list = lists.find(list => list.lname.toLowerCase() == 'my wishlist') || lists[0];
            selectors.lid = list.lid;
        } else {
            const newList = await new Promise((resolve, reject) => {swat.createList({ lname: "Wishlist" }, resolve, reject);});
            selectors.lid = newList.lid;
            console.log("New list created:", newList.lid);
        }
        return selectors.lid;
    } catch (err) {
        console.error(err);
    }
}

function _showPopupContainer (selector) {
    selectors.body.classList.add('no-scroll');
    selector.classList.remove('swym-hide-container');
    selector.classList.add('swym-active-popup');
}

function _hidePopupContainer (selector) {
    selectors.body.classList.remove('no-scroll');
    selector.classList.add('swym-hide-container');
    selector.classList.remove('swym-active-popup');
}

function _openWishlistPopup(target){
    if((target.dataset.action == 'remove-item')||(target.title == "Set quantity to 0"))
    {
        const card = target.closest('.CartItem');
        const image = card.querySelector('.CartItem__Image');
        const name = card.querySelector('h2.CartItem__Title.Heading a');
        const variant = card.querySelector('.CartItem__Variant');
        selectors.imageURL = image.src;
        selectors.product = {
            epi: target.dataset.swymEpi,
            empi: target.dataset.swymEmpi,
            du: target.dataset.swymDu
        }
        selectors.image.src = selectors.imageURL;
        selectors.name.textContent = name.textContent;
        selectors.variant.textContent = variant.textContent;
        _showPopupContainer(selectors.popup);
    }
}

function _addProductToWishlist(){
    let onSuccess = function (addedListItem){
        _hidePopupContainer(selectors.popup);
        SwymStorefrontLayoutExtensions?.Notification?.setMessage({
            message: SwymStorefrontLayoutContext?.Strings?.notificationMessageItemSaved,
            status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
            actionType: SwymStorefrontLayoutContext?.NotificationActionTypes.AddedToWishlist,
            duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
            product:null,
            image:selectors.imageURL
        },{
            showImage: true,
            showProgress: true
        });
    }
    let onError = function (error){
        console.log("Error while adding the Product to the List", error);
    }
    swat.addToList(selectors.lid, selectors.product, onSuccess, onError);
}

function _overlayEvent(evt){
    if (evt.target.classList.contains('PageOverlay'))
        document.querySelectorAll(".swym-active-popup").forEach(popup => _hidePopupContainer(popup));
    if (evt.target.nodeName == 'BODY')
        document.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
}

function _attachEventListeners(){
    selectors.drawer.addEventListener('click', evt => _openWishlistPopup(evt.target));
    selectors.body.addEventListener('click', evt => _overlayEvent(evt));
    selectors.close.addEventListener('click', evt => _hidePopupContainer(selectors.popup));
    selectors.cancel.addEventListener('click', evt => _hidePopupContainer(selectors.popup));
    selectors.add.addEventListener('click', evt => _addProductToWishlist());
}

async function onSwymLoadCallback(swat) {
    _initializeSelectors();
    await _getListID(swat);
    _attachEventListeners();
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

window.SwymCallbacks.push(onSwymLoadCallback);